import React from 'react'

import type {
  SuggestedPrompt,
  SuggestedPromptsResult,
} from '~/hooks/useAgentSuggestedPrompts'

import { MessageBubble } from './MessageBubble'
import { SuggestedActionButton } from './SuggestedActionButton'

import styles from './SuggestedPrompts.module.scss'

export interface SuggestedPromptsProps {
  onSuggestedPromptClick: (prompt: SuggestedPrompt) => void
  suggestedPrompts: SuggestedPromptsResult
}

export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({
  suggestedPrompts,
  onSuggestedPromptClick,
}) => (
  <div className={styles.suggestedPromptsContainer}>
    <MessageBubble sender="agent">
      <div className={styles.suggestedPromptsIntro}>
        {suggestedPrompts.introMessage}
      </div>
      <div className={styles.suggestedPromptsButtons}>
        {suggestedPrompts.prompts.map((suggestedPrompt) => (
          <div key={suggestedPrompt.id}>
            <SuggestedActionButton
              text={suggestedPrompt.buttonText}
              onClick={() => onSuggestedPromptClick(suggestedPrompt)}
            />
          </div>
        ))}
      </div>
    </MessageBubble>
  </div>
)

export default SuggestedPrompts
